/**
 * Snapshot of what the license list/map/details UI currently shows.
 * SSE overlap uses this instead of reading stale React state.
 */

export type DisplayedLicenseJlt = {
  licenseId: string;
  jurisdictionId: string;
  licenseTypeId: string;
  registrantAccountId?: string | null;
};

export type LicenseDisplayedSnapshot = {
  pageLicenseIds: string[];
  pageJlts: DisplayedLicenseJlt[];
  pinLicenseIds: string[];
  pinJlts: DisplayedLicenseJlt[];
  /** True when the map is showing area counts instead of one dot per license. */
  mapIsClustered?: boolean;
  openLicenseId: string | null;
  headerJurisdictionIds: string[];
  headerLicenseTypeIds: string[];
  headerRegistrantAccountIds: string[];
};

const EMPTY: LicenseDisplayedSnapshot = {
  pageLicenseIds: [],
  pageJlts: [],
  pinLicenseIds: [],
  pinJlts: [],
  openLicenseId: null,
  headerJurisdictionIds: [],
  headerLicenseTypeIds: [],
  headerRegistrantAccountIds: [],
};

let snapshot: LicenseDisplayedSnapshot = EMPTY;

export function getLicenseDisplayedSnapshot(): LicenseDisplayedSnapshot {
  return snapshot;
}

export function setLicenseDisplayedSnapshot(
  next: Partial<LicenseDisplayedSnapshot>,
): void {
  snapshot = { ...snapshot, ...next };
}

export function resetLicenseDisplayedSnapshot(): void {
  snapshot = EMPTY;
}
